import { Typography, TypographyProps } from "@mui/material";

export type CustomTypographyVariant =
  | "title_xxlarge"
  | "title_xlarge"
  | "title_large"
  | "title_medium"
  | "title_small"
  | "title_xsmall"
  | "subtitle"
  | "subtitle_small"
  | "body_large"
  | "body_small"
  | "button"
  | "caption"
  | "caption_2"
  | "textbox_default"
  | "textbox_bold"
  | "navbar_active"
  | "navbar_inactive";

type CustomProps = {
  variant: CustomTypographyVariant;
  numberOfLines?: number;
};

type Props = Omit<TypographyProps, keyof CustomProps> & CustomProps;

const Text = (props: Props) => {
  const { numberOfLines, children, ...typographyProps } = props;

  const numberOfLinesStyle = numberOfLines && {
    display: "-webkit-box",
    WebkitLineClamp: numberOfLines,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  return (
    // <Typography >
    <Typography {...typographyProps} sx={{ ...numberOfLinesStyle }}>
      {children}
    </Typography>
  );
};

export default Text;
